import { BetHistoryRowData } from '../../domain/betHistory/model/BetHistoryRowData'
import { Panel } from '../../UI/Panel'
import { Container, Graphics, Text } from '@pixi/react'
import { ColorMatrixFilter, TextStyle } from 'pixi.js'
import { formatToCommaWithLang } from '../../util/formatUtil'
import { useCallback, useState } from 'react'
import { Draw } from '../../type/PixiType'
import { soundManager, SoundType } from '../../domain/sound/SoundManager'
import { Image } from '../../UI/Image'

interface BetHistoryRowProps {
  x: number
  y: number
  data: BetHistoryRowData
  openBetDetail: (refNo: number, statementDate: string) => void
}

const width = 700
const colWidth = width / 4
const height = 60

const textStyle = new TextStyle({
  fill: '#C1C1C1',
  fontSize: 20,
  wordWrap: true,
  breakWords: true,
  wordWrapWidth: colWidth,
})

const refnoStyle = new TextStyle({
  fill: '#ECC350',
  fontSize: 20,
  wordWrap: true,
  breakWords: true,
  wordWrapWidth: colWidth,
})

const colorMatrix = new ColorMatrixFilter()
const hexColor = 0xDEC56C
const r = ((hexColor >> 16) & 0xFF) / 255
const g = ((hexColor >> 8) & 0xFF) / 255
const b = (hexColor & 0xFF) / 255

colorMatrix.matrix = [
  0, 0, 0, 0, r,
  0, 0, 0, 0, g,
  0, 0, 0, 0, b,
  0, 0, 0, 1, 0,
]

export const BetHistoryRowPortrait = (props: BetHistoryRowProps) => {
  const [isHovering, setIsHovering] = useState(false)
  const displayStake = props.data.voucherStake > 0
    ? `0 (${formatToCommaWithLang(props.data.voucherStake)})`
    : formatToCommaWithLang(props.data.stake)

  const draw: Draw = useCallback<Draw>((g) => {
    g.clear()
    g.lineStyle(2, isHovering ? '#403F3F' : '#2D2C2C') // 2 pixels thick, red color
    g.moveTo(0, height - 1)
    g.lineTo(width, height - 1)
  }, [isHovering])

  return (

    <Container
      x={props.x}
      y={props.y}

      eventMode="static"
      cursor="pointer"
      pointerdown={() => {
        soundManager.play(SoundType.buttonConfirm)
      }}
      onpointertap={() => {
        props.openBetDetail(props.data.refNo, props.data.statementDate)
      }}
      pointerover={() => {
        setIsHovering(true)
      }}
      pointerout={() => {
        setIsHovering(false)
      }}
    >
      <Panel name="BetHistoryRow" x={0} y={0} width={width} height={height} backgroundColor={isHovering ? '#2A2A2A' : '#161616'}>
        <Text text={props.data.orderTime} x={85} y={height / 2} anchor={[0.5, 0.5]} style={textStyle} />
        <Text
          text={props.data.refNo.toString()}
          x={265}
          y={height / 2}
          anchor={[0.5, 0.5]}
          style={refnoStyle}
        />

        <Text
          text={displayStake}
          x={515}
          y={height / 2}
          anchor={[1, 0.5]}
          style={textStyle}
        />
        <Text
          text={formatToCommaWithLang(props.data.payout)}
          x={690}
          y={height / 2}
          anchor={[1, 0.5]}
          style={textStyle}
        />
        <Graphics draw={draw} />

      </Panel>
      {props.data.voucherStake > 0
        ? (
            <Image
              name="voucher_History"
              image="voucher_History"
              width={218}
              height={33}
              anchor={[0.5, 0.5]}
              scale={0.7}
              x={265}
              y={5}
            />
          )
        : null}

    </Container>

  )
}
